import ValidationTimeline from "../validationTimeline/ValidationTimeline";

const ValidationToolsWidget = ({
  instances,
  isLoadingViews,
  refreshData,
  validationMode,
  onRegionChange,
  allDrrLabelsAssigned,
  onRerunLandmarking,
  viewReloadToken,
  disabled,
  onCheckReloadRequested,
  annotationsMap,
}) => {
  return (
    <ValidationTimeline
      instances={instances}
      isLoadingViews={isLoadingViews}
      refreshData={refreshData}
      validationMode={validationMode}
      onRegionChange={onRegionChange}
      allDrrLabelsAssigned={allDrrLabelsAssigned}
      onRerunLandmarking={onRerunLandmarking}
      viewReloadToken={viewReloadToken}
      disabled={disabled}
      onCheckReloadRequested={onCheckReloadRequested}
      annotationsMap={annotationsMap}
    />
  );
};

export default ValidationToolsWidget;
